import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/dashboard'

export default {
  namespaced: true,
  state: {
    cacheInfo: [],
    loadings: {
      counters: false,
      meetInterviews: false,
      realtyTypeInterviews: false,
      statusCodeInterviews: false,
      overviewTable: false,
    },
    dashboardData: {
      counters: {
        sales: {
          saleCount: 0,
          totalCount: 0,
        },
        analysisAmount: [
          {
            amount: 0,
            symbol: null,
          },
          {
            amount: 0,
            symbol: null,
          },
        ],
        turnoverAmount: [
          {
            amount: 0,
            symbol: null,
          },
          {
            amount: 0,
            symbol: null,
          },
        ],
        interviews: {
          interviewCount: 0,
          saleRates: 0,
        },
      },
      meetInterviews: {
        series: [],
        categories: [],
        colors: [],
      },
      realtyTypeInterviews: {
        series: [],
        categories: [],
        colors: [],
      },
      statusCodeInterviews: {
        series: [],
        categories: [],
        colors: [],
      },
      overviewTable: {
        rows: [],
        grandTotals: {
          stockCount: 0,
          saleCount: 0,
          saleableCount: 0,
          dueDates: 0,
          interviewCount: 0,
          statusACount: 0,
          statusBCount: 0,
          statusCCount: 0,
        },
      },
    },
    projects: [],
    downloadFile: {
      filename: null,
    },
  },
  getters: {
    cacheInfo(state) {
      return state.cacheInfo
    },
    loadings(state) {
      return state.loadings
    },
    dashboardData(state) {
      return state.dashboardData
    },
    projects(state) {
      return state.projects
    },
    downloadFile(state) {
      return state.downloadFile
    },
  },
  mutations: {
    SET_LOADINGS(state, data) {
      if (data.type === 'counters') {
        state.loadings.counters = data.status
      }
      if (data.type === 'meetInterviews') {
        state.loadings.meetInterviews = data.status
      }
      if (data.type === 'realtyTypeInterviews') {
        state.loadings.realtyTypeInterviews = data.status
      }
      if (data.type === 'statusCodeInterviews') {
        state.loadings.statusCodeInterviews = data.status
      }
      if (data.type === 'overviewTable') {
        state.loadings.overviewTable = data.status
      }
    },

    SET_DASHBOARD_DATA(state, data) {
      if (data.type === 'counters') {
        state.dashboardData.counters = data.data
      }
      if (data.type === 'meetInterviews') {
        state.dashboardData.meetInterviews = data.data
      }
      if (data.type === 'realtyTypeInterviews') {
        state.dashboardData.realtyTypeInterviews = data.data
      }
      if (data.type === 'statusCodeInterviews') {
        state.dashboardData.statusCodeInterviews = data.data
      }
      if (data.type === 'overviewTable') {
        state.dashboardData.overviewTable = data.data
      }
      if (data.type === 'projects') {
        state.projects = data.data
      }
      if (data.type === 'downloadFile') {
        state.downloadFile = data.data
      }
    },
    SET_CACHE_INFO(state, data) {
      state.cacheInfo = data
    },
    /* RESET MUTATIONS */
    RESET_DASHBOARD_DATA(state) {
      state.dashboardData = {
        counters: {
          sales: {
            saleCount: 0,
            totalCount: 0,
          },
          analysisAmount: [
            {
              amount: 0,
              symbol: null,
            },
            {
              amount: 0,
              symbol: null,
            },
          ],
          turnoverAmount: [
            {
              amount: 0,
              symbol: null,
            },
            {
              amount: 0,
              symbol: null,
            },
          ],
          interviews: {
            interviewCount: 0,
            saleRates: 0,
          },
        },
        meetInterviews: {
          series: [],
          categories: [],
          colors: [],
        },
        realtyTypeInterviews: {
          series: [],
          categories: [],
          colors: [],
        },
        statusCodeInterviews: {
          series: [],
          categories: [],
          colors: [],
        },
        overviewTable: {
          rows: [],
          grandTotals: [],
        },
      }
    },
  },
  actions: {
    getData({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      const data = JSON.stringify(params)
      return axiosIns
        .post(`${ROOT_URL}/realtySalesLive?type=${params.type}`, data)
        .then(response => {
          commit('SET_DASHBOARD_DATA', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
          return response
        })
        .catch(error => console.error(error))
    },
    refreshData({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/realtySalesLive?type=${params.type}&noCache=true`, data)
        .then(response => {
          commit('SET_DASHBOARD_DATA', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
  },
}
